'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

/**
 * Get valid langKey in langs or return defaultLangKey
 * @func
 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
 * @param {String} defaultLangKey default browser language key
 * @returns {String} valid langKey
 */
var getValidLangKey = (0, _ramda.curry)(function (langs, defaultLangKey, langKey) {
  if ((0, _ramda.isNil)(langKey)) {
    return defaultLangKey;
  }

  var currentLangKey = (0, _ramda.filter)(function (l) {
    return (0, _ramda.startsWith)(l, langKey);
  }, langs);
  return currentLangKey[0] || defaultLangKey;
});

exports.default = getValidLangKey;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/getValidLangKey.js
// module id = 113
// module chunks = 34471704633725 35783957827783 216468464745311